import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { Button, FormLabel, Badge } from 'react-bootstrap';
import withRouter from 'js/withRouter';
import _ from 'lodash';
import { getNameInCurrentLanguage } from 'helpers/intl';
import MainMenuLinkNotification from 'components/layout/mainMenus/common/MainMenuLinkNotification';
import MainMenuLink from "components/layout/mainMenus/common/MainMenuLink";
import {
  getAllNotificationsR,
  getFileViaNotificationR,
  socketConnectNotifications,
  setAsReadR
} from 'actions/RealTimeNotificationActions';
import { socketConnectRealtimeEvents } from 'actions/RealtimeEventActions';
import {addNotification} from "actions/NotificationsActions";
import IntlDate from "components/layout/IntlDate";
import { entityMetaMapping } from 'js/constants';
import {
  getPrintJobNotificationEditionId,
  getNotificationEntityId,
  getPrintJobNotificationDownload,
  isMatchingEditorRoute,
} from 'helpers/printJobNotificationDownloads';
import PrintJobNotificationContext from 'components/layout/Notifications/PrintJobNotificationContext';


class NotificationMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessages: 5,
      unreadNotifications: 0,
    };
    this.index = 1300;
  }

  componentDidMount = () => {
    const { user, getAllNotificationsR, connectNotificationsSocket, connectRealtimeEventsSocket } = this.props;
    getAllNotificationsR({ clientId: user.username });
    connectNotificationsSocket();
    connectRealtimeEventsSocket();
  };

  componentDidUpdate = prevProps => {
    const { doNotify, notifications, latestNotification, history, appIntl, goToData, downloadData, setAsReadR, intl: { messages }, location } = this.props;
    let notification;
    const { unreadNotifications } = this.state;
    let _unreadNotifications = unreadNotifications;
    let actionFlag = latestNotification?.entityDocIdentifier || latestNotification?.entity_doc_identifier;
    const latestDownload = getPrintJobNotificationDownload(latestNotification);
    let targetActionTitle = "";
    if (latestDownload) {
      targetActionTitle = actionFlag === entityMetaMapping.orderItem ? messages.go_to_order : messages.go_to_edition;
    } else if (actionFlag === entityMetaMapping.edition) {
      targetActionTitle = messages.go_to_edition;
    } else if (actionFlag === entityMetaMapping.orderItem) {
      targetActionTitle = messages.go_to_order;
    }


    if (prevProps.latestNotification?.cdate !== latestNotification?.cdate) {
      notification = (
        <div style={{ maxWidth: 230, lineHeight: 1.35, minWidth: 0 }}>
          <div className="small text-muted m-b-5">
            <IntlDate date={latestNotification?.cdate} />
          </div>
          <div className="m-b-5">{latestNotification?.description}</div>
          {(latestDownload || getPrintJobNotificationEditionId(latestNotification)) && (
            <div
              className="m-t-5 p-t-5"
              style={{ borderTop: '1px solid rgba(0, 0, 0, 0.08)', minWidth: 0 }}
            >
              <PrintJobNotificationContext
                notification={latestNotification}
                appIntl={appIntl}
                messages={messages}
                compact
              />
            </div>
          )}
        </div>
      );
      if (latestDownload && isMatchingEditorRoute(latestNotification, location?.pathname)) {
        this.openNotificationDownload(latestNotification);
      }
      doNotify(
        2,
        notification,
        latestNotification?.id,
        latestDownload ? messages.export_download : targetActionTitle,
        latestDownload ? "SET_READ_AND_DOWNLOAD" : "SET_READ_AND_GO_TO",
        latestDownload ? targetActionTitle : null
      );
    }

    if (prevProps.notifications.length !== notifications.length || JSON.stringify(prevProps.notifications) !== JSON.stringify(notifications)) {
      _unreadNotifications = 0;
      _.forEach(notifications, notification => {
        if (!notification.read) {
         _unreadNotifications++;
        }
      });

      this.setState({ unreadNotifications: _unreadNotifications }, () => {});
    }

    if (downloadData && prevProps.downloadData?.id !== downloadData?.id) {
      const notificationIndex = _.findIndex(notifications, notification => notification.id === downloadData?.id);
      const notificationToDownload = notifications?.[notificationIndex];
      if (notificationToDownload) {
        this.openNotificationDownload(notificationToDownload, true);
      }
    }

    if (goToData && prevProps.goToData?.id !== goToData?.id) {
      const index = _.findIndex(notifications, notification => notification.id === goToData?.id);
      const notificationToOpen = notifications?.[index];
      const goToActionFlag = notificationToOpen?.entityDocIdentifier || notificationToOpen?.entity_doc_identifier;
      setAsReadR(goToData?.id);
      if (goToActionFlag === entityMetaMapping.edition) {
        let editionId = getNotificationEntityId(notificationToOpen);
        let url = appIntl.urlPrefix + 'editor/' + editionId;
        /** as an alternative to a hard reload we could use -> window.location.href = url; */
        history.push(url);
      } else if (goToActionFlag === entityMetaMapping.orderItem) {
        const notifMetadata = notificationToOpen?.metadata;
        let leadId = notifMetadata?.lead_id || notifMetadata?.leadId;
        if (leadId) {
          let url = appIntl.urlPrefix + 'account/leads/' + leadId + '#dataproof';
          history.push(url);
        } else {
          let orderId = notifMetadata?.parent_entity_id || notifMetadata?.parentEntityId;
          let url = appIntl.urlPrefix + 'account/orders/' + orderId;
          history.push(url);
        }
      }
    }


  };

  showMoreMessages = (event) => {
    event.stopPropagation();
    this.setState(prevState => ({
      showMessages: prevState.showMessages + 5,
    }));
  };

  showLessMessages = () => {
    this.setState(prevState => ({
      showMessages: prevState.showMessages - 5,
    }));
  };

  openNotificationDownload = (notification, markAsRead = false) => {
    const { getFileViaNotificationR, intl: { messages }, setAsReadR } = this.props;
    const download = getPrintJobNotificationDownload(notification);
    if (!download) {
      return false;
    }

    if (markAsRead && notification?.id) {
      setAsReadR(notification.id);
    }

    getFileViaNotificationR(messages, download.files, download.fileType);
    return true;
  };

  goToNotificationTarget = (action, entityId, id, metadata = {}) => {
    const { history, appIntl, setAsReadR } = this.props;
    setAsReadR(id);
    if (action === entityMetaMapping.edition) {
      let url = appIntl.urlPrefix + 'editor/' + entityId;
      history.push(url);
    } else if (action === entityMetaMapping.orderItem) {
      let leadId = metadata?.lead_id || metadata?.leadId;
      if (leadId) {
        let url = appIntl.urlPrefix + 'account/leads/' + leadId + '#dataproof';
        history.push(url);
      } else {
        let orderId = metadata?.parent_entity_id || metadata?.parentEntityId || entityId;
        let url = appIntl.urlPrefix + 'account/orders/' + orderId;
        history.push(url);
      }
    }
  };

  renderPrintJobContext = notification => {
    const { appIntl, intl: { messages } } = this.props;
    return (
      <PrintJobNotificationContext
        notification={notification}
        appIntl={appIntl}
        messages={messages}
        compact
      />
    );
  };

  renderPrintJobActions = notification => {
    const { intl: { messages } } = this.props;
    const download = getPrintJobNotificationDownload(notification);
    if (!download) {
      return null;
    }

    const actionFlag = notification.entityDocIdentifier || notification.entity_doc_identifier;
    const entityId = actionFlag === entityMetaMapping.orderItem
      ? notification.metadata?.parent_entity_id || notification.metadata?.parentEntityId || notification.entityId || notification.entity_id
      : notification.entityId || notification.entity_id;

    return (
      <div className="m-t-5">
        <Button
          size="sm"
          variant="success"
          className="m-r-5"
          onClick={(event) => {
            event.stopPropagation();
            this.openNotificationDownload(notification, true);
          }}
        >
          {messages.export_download}
        </Button>
        <Button
          size="sm"
          variant="link"
          onClick={(event) => {
            event.stopPropagation();
            this.goToNotificationTarget(actionFlag, entityId, notification.id, notification.metadata);
          }}
        >
          {actionFlag === entityMetaMapping.orderItem ? messages.go_to_order : messages.go_to_edition}
        </Button>
      </div>
    );
  };

  renderNotification = ({ id, cdate, description, entityId, entity_id, read, title, type, entityDocIdentifier, entity_doc_identifier, metadata }) => {
    const { intl: { messages } } = this.props;
    const notification = { id, cdate, description, entityId, entity_id, read, title, type, entityDocIdentifier, entity_doc_identifier, metadata };
    let actionFlag = entityDocIdentifier || entity_doc_identifier;
    let actionId = entityId || entity_id;
    const isDownloadable = Boolean(getPrintJobNotificationDownload(notification));
    if (actionFlag === entityMetaMapping.orderItem) {
      actionId = metadata?.parent_entity_id || metadata?.parentEntityId;
    }
    return (
      <li className="notification-li" key={id}>
        <div
          className="rendered-notification padding-15"
          style={{ width: '100%', cursor: isDownloadable ? 'default' : 'pointer', borderBottom: '1px solid #e1e1e1' }}
          onClick={()=>{
            if (!isDownloadable) {
              this.notificationAction(actionFlag, actionId, id, metadata, notification);
            }
          }}
        >
          {read ?
            <>
              <h6>
                <IntlDate date={cdate} />
              </h6>
              <h5>
                  <span>
                    <i className="fa-light fa-envelope-open" /> {title}
                  </span>
              </h5>
              <h6 style={{textAlign: "left", minWidth: 0}}>
                <span>
                  {description}
                </span>
                {this.renderPrintJobContext(notification)}
                {this.renderPrintJobActions(notification)}
              </h6>

            </>
            :
            <>
              <h6>
                <strong>
                  <IntlDate date={cdate} />
                </strong>
              </h6>
              <h5>
                <strong>
                  <span>
                    <i className="fa-solid fa-envelope" /> {title}
                  </span>
                </strong>
              </h5>
                <h6 style={{textAlign: "left", minWidth: 0}}>
                  <strong>
                    <span>
                      {description}
                    </span>
                  </strong>
                  {this.renderPrintJobContext(notification)}
                  {this.renderPrintJobActions(notification)}
                </h6>
            </>
          }
        </div>
      </li>
    );
  };


  notificationAction = (action, entityId, id, metadata, notification) => {
    if (this.openNotificationDownload(notification, true)) {
      return;
    }

    this.goToNotificationTarget(action, entityId, id, metadata);
  };

  renderNotifications = () => {
    const { notifications } = this.props;
    const { showMessages } = this.state;

    const visibleNotifications = notifications.slice(0, showMessages).map(this.renderNotification);
    const remainingNotifications = notifications.length - visibleNotifications.length;

    if (remainingNotifications > 0) {
      return [
        ...visibleNotifications,
        <div className="p-t-10 text-center more_notifications" key="more">
          <Button variant="link" onClick={this.showMoreMessages}>
            <FormattedMessage
              id="more_notifications"
              values={{ count: remainingNotifications }}
            />
          </Button>
        </div>,
      ];
    } else {
      return visibleNotifications;
    }
  };


  getText = () => {
    const { unreadNotifications } = this.state;
    const { label } = this.props;
    const { notifications } = this.props;
    return (
      <>
        {!!label && label}
        {unreadNotifications > 0 && (
          <Badge
            className="overlayer top-left inline fs-10 badge-important"
            style={{ marginTop: '-8px', marginLeft: '14px' }}
          >
            {unreadNotifications}
          </Badge>
        )}
      </>
    );
  };

  getContent = () => {
    const { intl: { messages } } = this.props;
    const { notifications } = this.props;
    const { unreadNotifications } = this.state;
    return (
      <div className="clearfix menu-dropdown">
        <div
          className="dropdown-menu bg-transparent"
          style={{ position: 'static', display: 'block', float: 'none' }}
        >
          <div className="notification-div">
            <div className="clearfix">
              {!!notifications.length && (
                <div className="pull-left padding-15 count-notifications">
                  <p>
                    <FormattedMessage id="count_notifications" values={{ count: notifications.length }} />
                    <br/>
                    <FormattedMessage id="count_unread_notifications" values={{ count: unreadNotifications }} />
                  </p>
                </div>
              )}
              {!notifications.length &&
                <h5 className="padding-15">{messages.no_notifications}</h5>
              }
              <ul className="dropdown-menu bg-transparent no-border no-padding no-shadow" style={{ position: 'static', display: 'block', float: 'none' }}>
                {this.renderNotifications()}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { appIntl, layout, onMouseEnter, onMouseLeave, currentIndex, animatingOut } = this.props;
    return (
      <MainMenuLinkNotification
        flipId=""
        index={this.index}
        currentIndex={currentIndex}
        layout={layout}
        onMouseEnter={onMouseEnter}
        onDropdownClose={onMouseLeave}
        hasDropdown
        animatingOut={animatingOut}
        id="menu-notifications"
        link={`/${appIntl.locale}/account/notifications`}
        className="relative"
        text={
          <span>
            <i className="fa-solid fa-bell"></i>
            {this.getText()}
          </span>
        }
        dropdownWidth={275}
        listClassName="menu-notifications"
        dropdownMenuElements={[
          {
            content: [{ type: 'raw', params: [{ name: 'content', value: this.getContent() }] }],
            language: appIntl.locale,
          },
        ]}
      />
    );
  }
}

const mapStateToProps = state => ({
  appIntl: state.intl,
  projectConfig: state.data.projectConfig,
  user: state.login.user,
  notifications: state.realTimeNotifications.notifications,
  latestNotification: state.realTimeNotifications.latestNotification,
  goToData: state.realTimeNotifications.goToData,
  downloadData: state.realTimeNotifications.downloadData
});

const mapDispatchToProps = dispatch => ({
  getAllNotificationsR: option => dispatch(getAllNotificationsR(option)),
  connectNotificationsSocket: () => dispatch(socketConnectNotifications()),
  connectRealtimeEventsSocket: () => dispatch(socketConnectRealtimeEvents()),
  setAsReadR: id => dispatch(setAsReadR(id)),
  getFileViaNotificationR: (messages, uploads, fileType) => dispatch(getFileViaNotificationR(messages, uploads, fileType)),
  doNotify: (code, text, notificationId, actionTitle, actionType = "SET_READ_AND_GO_TO", secondaryActionTitle = null) => {
    const notificationAction = {
      action: JSON.stringify({
        type: actionType,
        payload: {
          id: notificationId,
        },
      }),
      title: actionTitle,
    };
    const actions = [notificationAction];
    if (secondaryActionTitle) {
      actions.push({
        action: JSON.stringify({
          type: "SET_READ_AND_GO_TO",
          payload: {
            id: notificationId,
          },
        }),
        title: secondaryActionTitle,
      });
    }
    dispatch(addNotification(code, text, {actions}));
  },
});

export default withRouter(legacyInjectIntl(connect(mapStateToProps, mapDispatchToProps)(NotificationMenu)));
